export default {
  MAX_IMAGE_SIZE_LOGO: 2 * 1024 * 1024,
};
